import React from 'react';
import {withSystem, Atom} from '@packages/systems/wfdl';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {buttonStyle} from './styles';

import {TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const DiscountsButton = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const attributesWithAriaLabel = attributes.set(
      'aria-label',
      'Apply Discount'
    );

    return (
      <button {...generateAttributes(attributesWithAriaLabel, classes)}>
        {getString(getInPojo(data, ['buttonText']))}
      </button>
    );
  }
);

const config = createIntegratedAtom({
  showEmpty: false,
  render: DiscountsButton,
  displayName: 'Apply Button',
  constraints: {
    ancestors: [{is: 'CommerceCheckoutDiscounts', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          ...buttonStyle,
          borderTopLeftRadius: px(3),
          borderTopRightRadius: px(3),
          borderBottomRightRadius: px(3),
          borderBottomLeftRadius: px(3),
          marginLeft: px(8),
          flexShrink: 0,
          flexGrow: 0,
          height: px(38),
        },
      },
    },
  },
  fields: {
    buttonText: withSystem(
      {
        defaultValue: 'Apply',
        label: 'Button Text',
        displayName: 'Button Text',
      },
      TText
    ),
  },
});

export default config;
